import React from "react";
import injectSheet from "react-jss";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FloorplanItem = ({
  classes,
  name,
  url,
  onClick,
  active,
  uuid,
  onDeleteFloorplan,
}) => (
  <div
    className={clsx(classes.plan, {
      [classes.active]: active,
    })}
    onClick={onClick}
  >
    <div className={classes.header}>
      <div className={classes.planName}>{name}</div>
      {uuid && (
        <div
          className={classes.delete}
          onClick={e => {
            e.preventDefault();

            onDeleteFloorplan(uuid);
          }}
        >
          <FontAwesomeIcon
            icon={["fal", "trash-alt"]}
            className={classes.deleteIcon}
          />
        </div>
      )}
    </div>
    <img
      src={url.replace("dev.movein360.com", "movein.theatro360.com")}
      alt={name}
    />
  </div>
);

const styles = theme => ({
  plan: {
    width: "100%",
    border: `1px solid ${theme.colorGrey}`,
    "border-radius": theme.borderRadius,
    "margin-bottom": theme.spacing2,
    "background-color": theme.colorBackground,
    padding: theme.spacing2,
    "box-sizing": "border-box",
    "line-height": 0,
    cursor: "auto",
    "z-index": 1,
    "transition-property": "border-color",
    "transition-duration": theme.transitionDuration,
    "user-select": "none",
    "transform-origin": "top left",

    "& img": {
      "border-radius": theme.borderRadius,
      width: "100%",
      "pointer-events": "none",
    },
  },
  planName: {
    "text-align": "left",
    color: theme.textColor,
    "padding-bottom": theme.spacing2,
    "line-height": "1rem",
    flex: 1,
  },
  active: {
    "border-color": theme.colorPrimary,
    "font-weight": "bold",
  },
  header: {
    display: "flex",
  },
  delete: {
    cursor: "pointer",
  },
  deleteIcon: {
    color: theme.colorSecondary,
  },
});

export default injectSheet(styles)(FloorplanItem);
